/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import {
    ARCHITECTURE_1oo1,
    ARCHITECTURE_1oo2,
    ARCHITECTURE_1oo3,
    ARCHITECTURE_2oo2,
    ARCHITECTURE_2oo3,
    ARCHITECTURE_2oo4,
} from "const"
import { SilArchitecture } from "client/utils"

interface Isa_tr84_2002 {
    architecture: SilArchitecture
    mttr: number
    beta: number
    t1: number
    safeFailure: number
    dangerousFailure: number
    sd: number
    su: number
    dd: number
    du: number
}

// "**" (double "*") is an equivalent of "Math.pow"
export const isa_tr84_2002_PFD = ({
    architecture,
    mttr,
    beta,
    t1,
    safeFailure,
    dangerousFailure,
    sd,
    su,
    dd,
    du,
}: Isa_tr84_2002) => {
    const s = S({ su, sd })
    let pfd: number
    let str: number

    if (architecture === ARCHITECTURE_1oo1) {
        pfd = (du * (t1 / 2)) + (dangerousFailure * (t1 / 2))
        str = s + dd + safeFailure
    }

    if (architecture === ARCHITECTURE_1oo2) {
        pfd = ((((1 - beta) * du) ** 2 * t1 ** 2) / 3) + ((1 - beta) * du * dd * mttr * t1) + (beta * du * (t1 / 2)) + (dangerousFailure * (t1 / 2))
        str = 2 * (s + dd) + beta * (s + dd) + safeFailure
    }

    if (architecture === ARCHITECTURE_1oo3) {
        pfd = ((du ** 3 * t1 ** 3) / 4) + (du ** 2 * dd * mttr * t1 ** 2) + (beta * ((du * t1) / 2)) + ((dangerousFailure * t1) / 2)
        str = 3 * (s + dd) + beta * (s + dd) + safeFailure
    }

    if (architecture === ARCHITECTURE_2oo2) {
        pfd = (du * t1) + (beta * du * t1) + ((dangerousFailure * t1) / 2)
        str = 2 * s * (s + dd) * mttr + beta * (s + dd) + safeFailure
    }

    if (architecture === ARCHITECTURE_2oo3) {
        pfd = (du ** 2 * t1 ** 2) + ((3 * du) * dd * mttr * t1) + ((beta * du * t1) / 2) + ((dangerousFailure * t1) / 2)
        str = 6 * s * (s + dd) * mttr + beta * (s + dd) + safeFailure
    }

    if (architecture === ARCHITECTURE_2oo4) {
        pfd = (du ** 3 * t1 ** 3) + (4 * du ** 2 * dd * mttr * t1 ** 2) + (beta * du * (t1 / 2)) + (dangerousFailure * (t1 / 2))
        str = 12 * (s + dd) ** 3 * mttr ** 2 + (beta * (s + dd)) + safeFailure
    }

    return { pfd, str }
}


// used formulas
interface SProps {
    sd: number
    su: number
}
export const S = ({ sd, su }: SProps) => (
    su + sd
)
